var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"gallery-banner",class:{ compact: _vm.compact },attrs:{"to":_vm.url}},[_c(_vm.bannerComponent(_vm.resource),{tag:"component",attrs:{"resource":_vm.resource}}),(_vm.caption)?_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }